import request from '@/utils/request'

export function fetchHappeningList (query) {
  return request({
    url: '/card/api/happening/index',
    method: 'get',
    params: query
  })
}

export function fetchHappening (id) {
  return request({
    url: '/card/api/happening/view',
    method: 'get',
    params: { id }
  })
}

export function createHappening (data) {
  return request({
    url: '/card/api/happening/insert',
    method: 'post',
    data
  })
}

export function updateHappening (data) {
  return request({
    url: '/card/api/happening/update',
    method: 'post',
    data
  })
}

export function deleteHappening (id) {
  return request({
    url: '/card/api/happening/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/happening.js